import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=ab518e12&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab518e12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab518e12')) {
      api.createRecord('ab518e12', component.options)
    } else {
      api.reload('ab518e12', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=ab518e12&scoped=true&", function () {
      api.rerender('ab518e12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HhNIENO9CX6e/JS/comp/Accordion.vue"
export default component.exports